import { FC, useState } from "react";
import { Menu, MenuButton, MenuItem, useMenuState } from "@twilio-paste/menu";

import { AboutDialog } from "../../AboutDialog/AboutDialog";
// import { ConnectionOptionsDialog } from "../../ConnectionOptionsDialog/ConnectionOptionsDialog";
import { DeviceSelectionDialog } from "../../DeviceSelectionDialog/DeviceSelectionDialog";
import { ProductSettingsIcon } from "@twilio-paste/icons/esm/ProductSettingsIcon";
import { BackgroundSelectionDialog } from "../../BackgroundSelectionDialog/BackgroundSelectionDialog";
import { ENABLE_VIDEO } from "../.././../constants";
import { useAppState } from "../../../hooks/useAppState/useAppState";
import { Role } from "@ciptex/notified";
export const SettingsButton: FC = () => {
	const [aboutOpen, setAboutOpen] = useState(false);
	const [deviceSettingsOpen, setDeviceSettingsOpen] = useState(false);
	// const [connectionSettingsOpen, setConnectionSettingsOpen] = useState(false);
	const [backgroundSettingsOpen, setBackgroundSettingsOpen] = useState(false);
	const { appState } = useAppState();
	const menu = useMenuState();


	return (
		<>
			<MenuButton {...menu} variant="secondary">
				<ProductSettingsIcon decorative={false} title="Settings" />
			</MenuButton>
			<Menu {...menu} aria-label="Settings Actions">
				{(appState.participantType === Role.NOTIFIED_ADMIN || appState.participantType === Role.NOTIFIED_HOST) && <MenuItem {...menu} onClick={() => setAboutOpen(true)}>About</MenuItem>}
				<MenuItem {...menu} onClick={() => setDeviceSettingsOpen(true)}>Audio{ENABLE_VIDEO && " and Video"} Settings</MenuItem>
				{ENABLE_VIDEO && <MenuItem {...menu} onClick={() => setBackgroundSettingsOpen(true)}>Video Background Settings</MenuItem>}
				{/* <MenuItem {...menu} onClick={() => setConnectionSettingsOpen(true)}>Connection Settings</MenuItem> */}
			</Menu>
			{(appState.participantType === Role.NOTIFIED_ADMIN || appState.participantType === Role.NOTIFIED_HOST) && <AboutDialog open={aboutOpen} onClose={ () => setAboutOpen(false) } />}
			<DeviceSelectionDialog open={deviceSettingsOpen} onClose={() => { setDeviceSettingsOpen(false) }} />
			{ENABLE_VIDEO && <BackgroundSelectionDialog open={backgroundSettingsOpen} onClose={() => { setBackgroundSettingsOpen(false) }} />}
			{/* <ConnectionOptionsDialog open={connectionSettingsOpen} onClose={() => { setConnectionSettingsOpen(false) }} /> */}
		</>
	);
}
